import { ReactiveList } from "@appbaseio/reactivesearch";
import PropTypes from "prop-types";
import classNames from "classnames";
import React, { useState } from "react";
import StandardCard from "../../cards/standard-card/standard-card";
import styles from "./list-media.module.scss";
import Empty from "../../../common/empty/empty";
import util from "../../../../services/util";
import { FaTrashAlt, FaSpinner } from "react-icons/fa";
import "font-awesome/css/font-awesome.min.css";


const ListMedia = ({ onMediaNavigate, mixedMedia, onSelectKeyword, defaultQueryFn, setData, showTiles, fnSetLastRefreshDate }) => {
  const [loadingMarkers, setLoadingMarkers] = useState(true);

  const renderStandardCards = (cards) => {
    const data = Array.isArray(cards) ? cards : [];
    if (data.length > 0) {
      setLoadingMarkers(false);
    } else {
      setLoadingMarkers(true);
    }

    return (
      <div>
        {loadingMarkers &&
          <div>
            <FaSpinner className={classNames('fa-spin', styles?.spinner)} />
          </div>
        }
        <br />
        <div className={data.length < 5 ? styles?.cardLess : styles?.cards}>
          {data.map(item => (
            <StandardCard
              key={item._id}
              data={util.fixUrls(item)}
              onMediaNavigate={onMediaNavigate}
              onSelectKeyword={onSelectKeyword}
              fnSetLastRefreshDate={fnSetLastRefreshDate}
              className={data.length < 5 ? styles?.cardItem : ""}
            />
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className={styles?.container}>
      <ReactiveList
        defaultQuery={defaultQueryFn}
        className={styles?.wrap}
        componentId="SearchResult"
        dataField="name"
        title="ReactiveList"
        pagination={true}
        from={0}
        size={50}
        react={{
          and: [
            "searchKeywords",
            "searchTitle",
            "searchLocation",
            "searchType",
            "searchSource",
            "searchCopyright",
            "searchCaptureDate",
            "searchMulti",
            "searchDateUnknown",
            "searchPeople",
            "searchGroup",
            "searchOrganization",
            "searchPhotoNumber",
          ],
        }}
        onData={({ data }) => {
          // ReactiveList hands back { data, rawData, resultStats, ... } -- we only want the hits
          setData(Array.isArray(data) ? data : []);
        }}
        showLoader={false}
        render={({ Loading, error, data }) => {
          if (Loading) {
            return <div>Fetching Result...</div>;
          }
          if (error) {
            // Check if the error is about missing Elasticsearch index
            const errorString = JSON.stringify(error);
            const isIndexNotFound = errorString.includes('index_not_found_exception') || 
                                   errorString.includes('no such index');
            
            if (isIndexNotFound) {
              console.error('Elasticsearch index not found. Error:', error);
              console.error('Falling back to local data. mixedMedia length:', mixedMedia?.length);
              // Fall back to mixedMedia if Elasticsearch index doesn't exist
              if (mixedMedia && mixedMedia.length > 0) {
                return renderStandardCards(mixedMedia);
              } else {
                return <Empty title="Search index not available" content="The search index is not currently available. Please contact support or try again later." />;
              }
            }
            
            // For other errors, show the error details
            console.error('Elasticsearch error:', error);
            return <div>Something went wrong! Error details {errorString}</div>;
          }

          // Successfully loaded data from Elasticsearch
          console.log('ReactiveList data loaded successfully. Data length:', data?.length);

          return renderStandardCards(data || []);
        }}
        showResultStats={false}
        renderNoResults={() => (
          <Empty title="No results found" content="It seems we can’t find any results based on your search." />
        )}
      />
    </div>
  );
};

ListMedia.propTypes = {
  onMediaNavigate: PropTypes.func,
  onSelectKeyword: PropTypes.func,
  mixedMedia: PropTypes.array.isRequired,
  fnSetLastRefreshDate: PropTypes.func,
};

export default ListMedia;

